<template>
  <div class="tab config-tab section-layout-config-tab">
    <Background :background="options.background" @change="propChangedForAllViews('background', $event)" />
    <Divider />

    <Alignment :label="$t('content-align')" :options="options.align" @change="propChanged('align', $event)" />
    <Divider />

    <Spacement
      :label="$t('padding')"
      :options="options.padding"
      @change="propChanged(`padding.${$event.field}`, $event.value)"
    />

    <Toggle
      :label="$t('full-width')"
      :value="options.fullWidth"
      class="section-layout-config-tab__item"
      @toggle="propChanged('fullWidth', $event)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LayoutMixin from '@/components/sidenav/landing/shared/LayoutMixin.js'

export default {
  name: 'SectionSideNavLayoutTab',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.section.layout' },
  mixins: [LayoutMixin],
  methods: mapActions('landing', ['duplicate']),
}
</script>

<style lang="scss" scoped>
.config-tab {
  padding-bottom: 20px;
  .advanced-collapsible {
    margin: 10px -10px 0;
    padding: 0 !important;
  }
}

.section-layout-config-tab {
  background-color: white;
}

.section-layout-config-tab__item {
  margin-top: 12px;
}
</style>
